import { createFileRoute } from "@tanstack/react-router";
import { fetchGroup } from "@/features/groups/queries";
import { queryKeys } from "@/lib/query-keys";
import { GroupDetailPage } from "@/features/groups/pages/group-detail-page";

export const Route = createFileRoute("/_authed/tenants/$slug/groups/$groupId")({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.groups.detail(context.tenant.id, params.groupId),
      queryFn: () => fetchGroup(context.tenant.id, params.groupId),
    }),
  component: GroupDetailPage,
});
